import React from 'react';
import { Box, Text, Flex, Image, Grid, useColorModeValue, useColorMode } from '@chakra-ui/react';
import Boxx from "../../components/common/boxhome/boxx";
import Footer from "../../components/footer/footer";
import Scroll from "../../components/common/imagescroll/scroll";

const About: React.FC = () => {
  const bg = useColorModeValue('#E8E8E8', '#000000')
  const color = useColorModeValue('#FFFFF', 'white')
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Flex
      bg={useColorModeValue('white', '#1C1C1C')}

      direction="column"
      align="center"
      justify="center"
      height="auto"
      width="auto"
      padding="0"
      overflowX='hidden'
    >
      {/* Title Section */}
      <Box textAlign="left" mt="10px" width="auto">
        <Text
          textAlign="center"
          fontSize={{ base: '12px', md: '28px' }}
          color={color}
          fontWeight={400}
          lineHeight="36.4px"
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          About Us
        </Text>
      </Box>

      <Box textAlign="center" mt={{ base: '5%', md: '5%' }} mb={{ base: '40px', md: '20px' }}>
        <Text
          fontFamily="'Gilroy-SemiBold', sans-serif"
          fontSize={{ base: '32px', md: '64px' }}
          fontWeight="400"
          lineHeight={{ base: '40px', md: '58px' }}
          letterSpacing="-0.25px"
          color={color}
        >
          <Text as="span" >Who </Text>
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> we are</Text>
        </Text>
        <Box
          width="auto"
          height="auto"
          mx="auto"
          mt="10px"
          border="1.7px solid"
          sx={{
            borderImageSource: colorMode === 'light'
              ? 'linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
              : 'linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)',
            borderImageSlice: 1,
          }}
          borderRadius="md"
        />
      </Box>

      {/* Subtitle Section */}
      <Box textAlign="center" mt={{ base: '1%', md: '5%' }} mb={{ base: '10px', md: '20px' }} ml={{ base: 'center', md: '-48%' }}>
        <Text
          fontFamily="'Gilroy-SemiBold', sans-serif"
          fontSize={{ base: '32px', md: '64px' }}
          fontWeight="400"
          lineHeight={{ base: '40px', md: '58px' }}
          letterSpacing="-0.25px"
          color={color}
        >
          <Text as="span" >Delivering </Text>
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Different</Text>
        </Text>
      </Box>

      {/* Description Section */}
      <Flex
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
        width="auto"
        mt="40px"
        gap={{ base: '20px', md: '60px' }}
        px={{ base: '0px', md: '40px' }}
      >
        {/* Left Text Section */}
        <Text
          order={{ base: 1, md: 0 }}
          fontFamily="'Gilroy-Regular', sans-serif"
          fontSize={{ base: '16px', md: '28px' }}
          fontWeight="400"
          lineHeight={{ base: '24px', md: '36px' }}
          color={color}
          maxWidth={{ base: '90%', md: '50%' }}
          textAlign="justify"
          pl="10px"
          pr="10px"
          letterSpacing={{ base: '0.5px' }}
        >
          At RareToss Mediaworks, we believe in delivering more than just digital marketing services—we craft tailored solutions that drive meaningful growth for your business. Our name says it all: "Rare" represents our commitment to offering unique, out-of-the-box strategies, while "Toss" reflects our ability to efficiently execute tasks and deliver results that matter. With a team of creative minds and strategic thinkers, we partner with businesses to navigate the digital landscape, providing everything from branding to performance marketing. Our focus is always on delivering exceptional value and helping you stand out in a crowded marketplace.
        </Text>


        {/* Right Image Section */}
        <Box
          order={{ base: 0, md: 1 }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="auto"
          px={{ base: '0px', md: '0px' }}
        >
          <Image
            src="/assets/images/svg/aboutimage.svg"
            alt="aboutimage"
            maxWidth="80%"
            height="auto"
            mx="auto"
          />
        </Box>

      </Flex>


      {/* Section Title for 'How we Toss' */}
      <Box textAlign="left" mt="10px" width="auto">
        <Text
          textAlign="center"
          fontSize={{ base: '12px', md: '28px' }}
          color={color}
          fontWeight={400}
          lineHeight="36.4px"
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          How we Toss
        </Text>
      </Box>

      {/* Subtitle for 'Meet the Rare Minds' */}
      <Box width='auto' height='auto' mt='20px'>
        <Text
          fontSize={{ base: '32px', md: '64px' }}
          fontWeight='400'
          textAlign={{ base: 'center', md: 'center' }}
          color={color}
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          Our
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Work Flow </Text>
          Makes us
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Standout</Text>
        </Text>
      </Box>

      {/* New Section Design */}
      <Box width="100%" mt="50px" mb="50px" px={{ base: '20px', md: '40px' }}>
        <Grid templateColumns={{ base: '1fr', md: '1fr 1fr' }} gap={8}>
          {[
            {
              number: '1',
              title: 'Discover & Strategize',
              description: 'We dive deep into your goals to craft a custom strategy that fits your brand and objectives.',
              svg: '/assets/images/svg/aboutcardimage.svg',
            },
            {
              number: '2',
              title: 'Ideate & Innovate',
              description: 'Our team develops creative, data-driven solutions to help you stand out from the competition.',
              svg: '/assets/images/svg/aboutcardimage.svg',
            },
            {
              number: '3',
              title: 'Execute Flawlessly',
              description: 'We implement each strategy with precision, ensuring top-notch results across all platforms.',
              svg: '/assets/images/svg/aboutcardimage.svg',
            },
            {
              number: '4',
              title: 'Analyze & Improve',
              description: 'We continuously monitor performance and fine-tune our approach for ongoing growth and success.',
              svg: '/assets/images/svg/aboutcardimage.svg',
            },
          ].map((item, index) => (
            <Box
              key={index}
              bg={bg}
              borderRadius="lg"
              p={{ base: '20px', md: '50px' }}
              height={{ base: 'auto', md: '250px' }}
              position="relative"
              boxShadow="2xl"
              color={color}
              overflow="hidden"
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="flex-start"
              _hover={{
                '.image': { transform: 'translateX(100px)', opacity: 0 },
                '.text': { transform: 'translateX(-20px)' },
              }}
              transition="all 0.4s ease-in-out"
            >
              {/* SVG Background */}
              <Image
                src={item.svg}
                alt={`Background for ${item.title}`}
                className="image"
                position="absolute"
                left={{ base: '-10px', md: '-30px' }}
                top="0"
                height="100%"
                zIndex="1"
                transition="all 0.4s ease-in-out"
              />

              {/* Mobile Flex Container for Number and Title */}
              <Box display={{ base: 'flex', md: 'block' }} alignItems="center" ml={{ base: '0', md: '0' }}>
                {/* Circle Number */}
                <Box
                  as="span"
                  background="white"
                  color="black"
                  borderRadius="full"
                  width={{ base: '30px', md: '40px' }}
                  height={{ base: '30px', md: '40px' }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontWeight="bold"
                  fontSize={{ base: '16px', md: '24px' }}
                  mb={{ base: '0', md: '-42px' }}
                  ml={{ base: '0', md: '-10px' }}
                  zIndex="2"
                >
                  {item.number}
                </Box>

                {/* Title */}
                <Text
                  className="text"
                  lineHeight="1.2"
                  fontFamily="'Gilroy-SemiBold', sans-serif"
                  fontSize={{ base: '18px', md: '32px' }}
                  fontWeight="600"
                  color={color}
                  textAlign="left"
                  zIndex="2"
                  transition="all 0.4s ease-in-out"
                  ml={{ base: '10px', md: '50px' }}
                >
                  {item.title}
                </Text>
              </Box>

              {/* Description */}
              <Text
                className="text"
                fontSize={{ base: '12px', md: '20px' }}
                fontWeight="400"
                lineHeight={{ base: '18px', md: '30px' }}
                // color="gray.300"
                fontFamily="'Gilroy-SemiBold', sans-serif"
                color={color}
                textAlign="left"
                transition="all 0.4s ease-in-out"
                mt="10px"
                ml={{ base: '40px', md: '50px' }}
              >
                {item.description}
              </Text>
            </Box>
          ))}
        </Grid>
      </Box>

      <Box textAlign="left" mt="10px" width="auto">
        <Text
          textAlign="center"
          fontSize={{ base: '12px', md: '28px' }}
          color={color}
          fontWeight={400}
          lineHeight="36.4px"
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          Together We Toss
        </Text>
      </Box>

      {/* Subtitle for 'Meet the Rare Minds' */}
      <Box width='auto' height='auto' mt='20px'>
        <Text
          fontSize={{ base: '32px', md: '64px' }}
          fontWeight='400'
          textAlign={{ base: 'center', md: 'center' }}
          color={color}
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          Meet
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> the Rare Minds </Text>
          Behind
          <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> the Toss</Text>
        </Text>
      </Box>
      <Box
        width={{ base: '110%', md: "120%" }}
        display="flex"
        justifyContent="center"
        paddingX={{ base: '10%' }}
        mt="40px"
      >
        <Scroll />
      </Box>
      <Box textAlign="left" mt={{md:"100px",base:"50px"}} width="auto" >
        <Text
          textAlign="center"
          fontSize={{ base: '12px', md: '28px' }}
          color={color}
          fontWeight={400}
          lineHeight="36.4px"
          fontFamily="'Gilroy-Regular', sans-serif"
        >
          Get in touch
        </Text>
      </Box>
      <Boxx />
    
      <Footer />
    </Flex>
  );
};

export default About;
